import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

interface LineProgressProps {
  total: number;
  current: number;
}

const LineProgress: React.FC<LineProgressProps> = ({ total, current }) => {
  const progress = (current / total) * 100;

  return (
    <Box sx={{ width: "100%", textAlign: "right" }}>
      <Typography variant="caption" sx={{ m: 0, fontWeight: 600, color: '#459173' }}>
        {Math.round(progress)}%
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{ borderRadius: 6, my: 1, backgroundColor: '#E2F1EB' }}
      />
    </Box>
  );
};

export default LineProgress;
